import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, resolveComponent as _resolveComponent, toHandlers as _toHandlers, mergeProps as _mergeProps, createVNode as _createVNode, withCtx as _withCtx, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "flex flex-col sm:flex-row sm:items-start gap-3 flex-wrap" }
const _hoisted_2 = { class: "w-full sm:w-auto min-h-[56px]" }
const _hoisted_3 = { class: "w-full sm:w-auto min-h-[56px]" }
const _hoisted_4 = { class: "flex items-center gap-2 h-[48px] w-full sm:w-auto" }

import { watch } from 'vue'
import { DatePicker } from 'v-calendar'
import { mdiCalendar } from '@mdi/js'
import DsSwitch from '@/components/designSystem/Switch/index.vue'


export default /*#__PURE__*/_defineComponent({
  __name: 'PolicyVigencyFields',
  props: {
    startDate: {},
    endDate: {},
    indefiniteEndDate: { type: Boolean },
    maxDate: {},
    errors: {},
    testidPrefix: {}
  },
  emits: ["update:startDate", "update:endDate", "update:indefiniteEndDate", "clearError"],
  setup(__props: any, { emit }) {

const props = __props;





// Mesma dupla-emissao de clearError('endDate') que existia no componente pai
// (listener explicito no DsSwitch + watch reativo do valor) — quirk preservada.
const onIndefiniteEndDateChange = (value: boolean) => {
  emit('update:indefiniteEndDate', value)
  emit('clearError', 'endDate')
}

watch(
  () => props.indefiniteEndDate,
  (isIndefinite) => {
    if (isIndefinite) {
      emit('update:endDate', null)
      emit('clearError', 'endDate')
    }
  }
)

return (_ctx: any,_cache: any) => {
  const _component_v_text_field = _resolveComponent("v-text-field")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_unref(DatePicker), {
        "model-value": _ctx.startDate,
        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (emit('update:startDate', $event))),
        locale: "pt-BR",
        masks: { input: 'DD/MM/YYYY' },
        disabled: _ctx.indefiniteEndDate,
        "max-date": _ctx.maxDate,
        class: "w-full h-full"
      }, {
        default: _withCtx(({ inputValue, inputEvents }) => [
          _createVNode(_component_v_text_field, _mergeProps({
            "data-testid": `${_ctx.testidPrefix}-start-date-input`,
            placeholder: "Início da vigência",
            "append-inner-icon": _unref(mdiCalendar),
            value: inputValue
          }, _toHandlers(inputEvents), {
            density: "comfortable",
            variant: "outlined",
            color: "primary20",
            class: "w-full sm:w-[192px] h-full",
            error: !!_ctx.errors?.startDate,
            "error-messages": _ctx.errors?.startDate,
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (emit('clearError', 'startDate')))
          }), null, 16, ["data-testid", "append-inner-icon", "value", "error", "error-messages"])
        ]),
        _: 1
      }, 8, ["model-value", "disabled", "max-date"])
    ]),
    _createElementVNode("div", _hoisted_3, [
      _createVNode(_unref(DatePicker), {
        "model-value": _ctx.endDate,
        "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => (emit('update:endDate', $event))),
        locale: "pt-BR",
        masks: { input: 'DD/MM/YYYY' },
        disabled: _ctx.indefiniteEndDate,
        "max-date": _ctx.maxDate,
        class: "w-full h-full"
      }, {
        default: _withCtx(({ inputValue, inputEvents }) => [
          _createVNode(_component_v_text_field, _mergeProps({
            "data-testid": `${_ctx.testidPrefix}-end-date-input`,
            placeholder: "Fim da vigência",
            "append-inner-icon": _unref(mdiCalendar),
            value: inputValue
          }, _toHandlers(inputEvents), {
            density: "comfortable",
            variant: "outlined",
            color: "primary20",
            class: "w-full sm:w-[192px] h-full",
            disabled: _ctx.indefiniteEndDate,
            error: !!_ctx.errors?.endDate,
            "error-messages": _ctx.errors?.endDate,
            "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (emit('clearError', 'endDate')))
          }), null, 16, ["data-testid", "append-inner-icon", "value", "disabled", "error", "error-messages"])
        ]),
        _: 1
      }, 8, ["model-value", "disabled", "max-date"])
    ]),
    _createElementVNode("div", _hoisted_4, [
      _createVNode(DsSwitch, {
        "data-testid": `${_ctx.testidPrefix}-indeterminate-switch`,
        "model-value": _ctx.indefiniteEndDate,
        label: "Fim de vigência indeterminado",
        "onUpdate:modelValue": onIndefiniteEndDateChange
      }, null, 8, ["data-testid", "model-value"])
    ])
  ]))
}
}

})